import {
    changeEvent,
    customEvent,
    dispatchCustomEvent,
    keyupEvent
} from "../../../../../webpack/modules/events";
import {
    hideOptionErrors,
    renderPreviewImage, resetPreviewImage,
} from "../../../../../webpack/modules-optimized/product-page";
import {slideUp,slideDown} from "../../../../../webpack/modules-optimized/element-visibility";

keyupEvent('#product-page .options[data-option-type="selectable"] input[name="customText"], #product-page .options[data-option-type="selectable"] textarea[name="customText"]', false, function(element) {
    let container = element.closest('.product-scope')
    let offcanvas = element.closest('.offcanvas');
    let customText = element.value;
    let customImage = offcanvas.querySelector('input[name="custom-image"]');
    let customImageFromWeb = offcanvas.querySelector('input[name="customImageFromWeb"]');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let increment = offcanvas.querySelector('input[name="customPriceIncrement"]');
    let validate = offcanvas.querySelector('.validate');
    let customTextLength = element.dataset.maxlen ? parseInt(element.dataset.maxlen) : 0;
    let customTextLengthError = element.dataset.maxlenError ? element.dataset.maxlenError : '';
    let errorContainer = offcanvas.querySelector('.error');

    if (errorContainer && customTextLength && customText.length > customTextLength) {
        errorContainer.innerText = customTextLengthError;
        slideDown(errorContainer);
        validate.classList.add('disabled');
        return;
    } else {
        slideUp(errorContainer);
    }

    dispatchCustomEvent(
        'productCustomTextChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
            'increment': increment,
            'customText': element,
            'customImage': customImage,
            'customImageFromWeb': customImageFromWeb
        }
    );
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (customText === '' && validate) validate.classList.add('disabled');
    else if (validate && ((!customImage || customImage.value !== '') || (!customImageFromWeb || customImageFromWeb.checked))) validate.classList.remove('disabled');
    hideOptionErrors(offcanvas);
});

changeEvent('#product-page .options[data-option-type="selectable"] input[name="customPriceIncrement"]', false, function(element) {
    let container = element.closest('.product-scope')
    let offcanvas = element.closest('.offcanvas');
    if (!offcanvas.querySelector('input[name="customText"], textarea[name="customText"]')) return;
    let customText = offcanvas.querySelector('input[name="customText"], textarea[name="customText"]');
    let customImage = offcanvas.querySelector('input[name="custom-image"]');
    let customImageFromWeb = offcanvas.querySelector('input[name="customImageFromWeb"]');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let validate = offcanvas.querySelector('.validate');

    dispatchCustomEvent(
        'productCustomTextIncrementChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
            'customText': customText,
            'increment': element
        }
    );
    if (customText === '' && validate) validate.classList.add('disabled');
    else if (validate && ((!customImage || customImage.value !== '') || (!customImageFromWeb || customImageFromWeb.checked))) validate.classList.remove('disabled');
});

customEvent('hidden.bs.offcanvas', '.options[data-option-type="selectable"][data-type="customizer"]', false, async function(offcanvas) {
    let customText = offcanvas.querySelector('input[name="customText"], textarea[name="customText"]');
    if (!customText) return;
    if (!customText.value) {
        resetPreviewImage(offcanvas.closest('.product-scope'));
    }
    renderPreviewImage(offcanvas.closest('.product-scope'));
});